const topNav = [
  { id: 1, label: "Home", href: "/" },
  { id: 2, label: "About", href: "/about" },
  { id: 3, label: "Predict", href: "/predict" },
  { id: 4, label: "Profile", href: "/profile" },
  // { id: 5, label: "SignIn", href: "/signin" },
  // { id: 6, label: "SignUp", href: "/signup" },

];

export const getTopNav = () => {
  return topNav;
};
